import { EPreviewSize } from '@/src/types/common/SalesChannel';
import {
  ANIMATION,
  CONTENTS,
  GRID,
  MOUDLE_STYLE,
  TEXT,
  animationFields,
  contentTextFields,
  moduleStyleFields,
} from './constant';
import {
  editable,
  contentPages as cK,
  contentPagesToShow,
  moduleWidthSelect,
  leaveGap,
  overflowOption,
  moduleTypeSelect,
} from '@/src/tools/contentModulesFieldName';
import { ModalField, ResponsiveContainer, ResponsiveField } from '../util';
import i18n from '../i18n';
import {
  EModuleWidth,
  EOverflowOption,
  EResponsiveContentPageToShow,
  EResponsiveProductToShow,
  EnumModuleType,
} from '@/src/types/common/module';
import { replaceI18nVariables } from '@/src/tools/tools';
import { get } from 'lodash';
import { checkResponsiveContentGrid } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';

export default (values: any, responsiveType: EPreviewSize) => {
  const gridSetting = getGridSetting(values, responsiveType);
  const moduleStyleSetting = getModuleStyleTemplate(
    values,
    responsiveType,
    EnumModuleType.ResponsiveContentGrid,
  );
  const animationSetting = getAnimationTemplate(values, responsiveType);
  const contentSetting = getContentPageTemplate(values, responsiveType);
  return [
    {
      title: i18n['general.content.grid'],
      id: GRID,
      field: gridSetting,
      fields: [
        [moduleWidthSelect],
        [contentPagesToShow],
        [leaveGap],
        [overflowOption],
      ],
    },
    {
      title: i18n['general.content.moduleStyle'],
      id: MOUDLE_STYLE,
      type: ResponsiveContainer.ModuleStyle,
      field: moduleStyleSetting,
      fields: moduleStyleFields,
    },
    {
      title: i18n['general.content.animation'],
      id: ANIMATION,
      field: animationSetting,
      fields: animationFields,
    },
    {
      title: i18n['general.content.text'],
      id: TEXT,
      field: [
        {
          field: ResponsiveField.ContentText,
          disabled:
            responsiveType !== EPreviewSize.WIDE ||
            !(
              responsiveType === EPreviewSize.WIDE ||
              values[`${TEXT}_${editable}`]
            ),
        },
      ],
      fields: contentTextFields,
    },
    {
      title: i18n['general.content.contents'],
      id: CONTENTS,
      field: contentSetting,
      fields: [[cK]],
      headerErrorDependencies: [[cK], [contentPagesToShow], [overflowOption]],
      validator: (value, extra) => {
        // const i = get(value, 'contentPages');
        const { checkContentPagesError } = checkResponsiveContentGrid();
        const res = checkContentPagesError(value, extra);

        return res;
      },
    },
  ];
};

export const not_editable = [
  moduleTypeSelect,
  moduleWidthSelect,
  ...moduleStyle_not_editable,
  ...animation_not_editable,
  ...contentTextFields,
];

export const getGridSetting = (values: any, responsiveType: EPreviewSize) => {
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${GRID}_${editable}`];
  let commonFields: Array<any> = [
    {
      field: ResponsiveField.GridType,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: [
        {
          label: i18n['content.carouseltype.product'],
          value: EnumModuleType.ResponsiveProductGrid,
        },
        {
          label: i18n['content.carouseltype.content'],
          value: EnumModuleType.ResponsiveContentGrid,
        },
      ],
    },
    {
      field: ResponsiveField.ModuleWidth,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: [
        { label: i18n['general.content.none'], value: EModuleWidth.NONE },
        { label: i18n['general.content.wideWidth'], value: EModuleWidth.WIDE },
      ],
    },
    {
      field: ResponsiveField.ContentPageToShow,
      disabled: !v,
      options: contentToShowOptions(responsiveType),
    },
  ];
  if (get(values, 'contentPagesToShow') !== EResponsiveContentPageToShow.One) {
    commonFields = [
      ...commonFields,
      {
        field: ResponsiveField.LeaveGap,
        disabled: !v,
      },
    ];
  }
  if (responsiveType !== EPreviewSize.WIDE) {
    commonFields = [
      ...commonFields,
      {
        field: ResponsiveField.OverflowItems,
        disabled: !v,
        options: [
          {
            label: i18n['general.overflow.carousel'],
            value: EOverflowOption.Carousel,
          },
          {
            label: i18n['general.overflow.anotherline'],
            value: EOverflowOption.AnotherLine,
          },
          { label: i18n['general.overflow.hide'], value: EOverflowOption.Hide },
        ],
      },
    ];
  }
  return commonFields;
};

import {
  animation_not_editable,
  getModuleStyleTemplate,
  moduleStyle_not_editable,
} from './imageCarousel';
import { getAnimationTemplate } from './imageCarousel';

export const getContentPageTemplate = (
  values: any,
  responsiveType: EPreviewSize,
) => {
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${CONTENTS}_${editable}`];
  return [
    {
      field: ResponsiveField.Contents,
      hasModal: true,
      modalFunc: getModalTemplate,
      disabled: !v,
    },
  ];
};

export const getModalTemplate = () => {
  return {
    left: [{ field: ModalField.Content }],
    middle: [],
    right: [],
  };
};

export const contentToShowOptions = (breakpoint: EPreviewSize) => {
  switch (breakpoint) {
    case EPreviewSize.WIDE: {
      return [
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.one'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.One,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.twoportrait'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoPortrait,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.twolandscape'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoLandscape,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.three'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Three,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.four'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Four,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.five'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Five,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.six'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Six,
        },
      ];
    }
    case EPreviewSize.TABLET: {
      return [
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.one'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.One,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.twoportrait'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoPortrait,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.twolandscape'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoLandscape,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.three'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Three,
        },
      ];
    }
    case EPreviewSize.MOBILE: {
      return [
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.one'],
            i18n['general.label.product'],
          ),
          value: EResponsiveProductToShow.One,
        },
        {
          label: replaceI18nVariables(
            i18n['general.productinrow.twoportrait'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoPortrait,
        },
      ];
    }
  }
};
